module.exports = __webpack_public_path__ + "static/scale-model-of-em'-ty-in-hollywood-florida-1635e587641b51510c1881492e82531e.png";